import Paragraphs from "./Paragraphs";

function Text(props) {
    return (
        <div className={`bg-white rounded-2xl m-auto flex flex-col ${props.vertical ? "" : "lg:flex-row"} `}>
            <div className={`w-full ${props.vertical ? "lg:w-full" : "lg:w-2/3"} p-8 text-blue-dark flex flex-col justify-between`}>
                <div>
                    {props.title &&
                        <div className="text-3xl text-golden font-bold mb-4">
                            {props.title}
                        </div>
                    }
                    {props.paragraphs && <Paragraphs paragraphs={props.paragraphs} />}
                    {props.content}
                </div>
            </div>

        </div>
    );
}

export default Text;
